<template>
	<a-layout-footer style="text-align: center">Copyright © 2022 逛球街. All rights reserved.</a-layout-footer>
</template>

<script>
export default {
	data() {
		return {};
	}
};
</script>
